import { useTitle } from "#/utils/useTitle"

export default function Layout({ children }: { children?: React.ReactNode }) {
  useTitle('镜身')
  return <div className="w-full h-full overflow-hidden">{children}</div>
}
